module.exports = __webpack_public_path__ + "static/img/9.86773085.jpg";